import * as pageTypes from '../../consts/pageTypes';

import { IFooter, IFooterLink } from '../../interfaces';
import { blue, transparent, white } from '../../consts/variables';

import { CollapsibleDropDown } from '../CollapsibleDropDown/CollapsibleDropDown';
import { CollapsibleDropDownTitle } from '../CollapsibleDropDown/CollapsibleDropDownTitle';
import { ContactUs } from './ContactUs';
import { IState } from '../../reducers';
import { Link } from '../Link';
import { Newsletter } from '../Newsletter/Newsletter';
import React from 'react';
import { __ } from '../../helpers/TranslationService';
import { connect } from 'react-redux';

interface Props {
    footerMenu: IFooterLink[];
    footer: IFooter;
    phoneNumber: string;
    pageType: string;
    countryCode: string;
}

const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 0,
};
const styleFooterWrapper: React.CSSProperties = {
    padding: '10px 0',
    textAlign: 'center',
    background: blue,
    color: white,
};
const styleFooterLinksWrapper: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: 420,
    margin: '0 auto',
};
const styleFooterLink: React.CSSProperties = {
    flex: '1 0 auto',
    padding: '5px',
    fontSize: 14,
};
const styleFooterCopyright: React.CSSProperties = {
    fontSize: 16,
};
const styleFooterBold: React.CSSProperties = {
    fontWeight: 'bold',
};
const seoWrapper: React.CSSProperties = {
    background: transparent,
    color: white,
    borderBottom: 0,
    padding: '3px 0 0',
    marginBottom: 10,
};
const seoContainerStyle: React.CSSProperties = {
    justifyContent: 'center',
};
const seoTitleStyle: React.CSSProperties = {
    flex: '0 1 auto',
};
const seoChild: React.CSSProperties = {
    margin: 0,
};
const seoArrow: React.CSSProperties = {
    fill: white,
    width: 26,
    height: 20,
    padding: '0 5px',
};
const seoTitle: React.CSSProperties = {
    color: white,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: 15,
    marginBottom: 2,
    flex: '1 0 100%',
};
const seoBlockWrapper: React.CSSProperties = {
    margin: '10px 0',
    lineHeight: 1.5,
    fontSize: 14,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
};
const seoLink: React.CSSProperties = {
    margin: '0 10px',
    color: white,
};
const siteMapStyle: React.CSSProperties = {
    justifyContent: 'center',
};
const titleStyle: React.CSSProperties = {
    fontSize: 14,
};

const year: number = new Date().getFullYear();

function FooterComponent(props: Props) {
    const getFooterNavigation = () => {
        return props.footerMenu.map((item, index) => (
            <Link
                style={styleFooterLink}
                key={index}
                href={item.targetUrl}
                followLink={item.targetUrl.indexOf('http') !== -1}
            >
                <span>{item.title}</span>
            </Link>
        ));
    };
    const seoData = {
        columnOne: 'Ports of Departure',
        columnTwo: 'Countries',
        columnThree: 'Destinations',
        columnFour: 'Companies:',
        columnFive: 'ships',
    };
    const getFooter = () => {
        const seoBlocks = Object.keys(seoData).map((val, idx) => {
            const seo = props.footer[val];
            const seoLinks = seo.items.map((val, key) => (
                <Link rel={val.title} href={val.targetUrl} key={key} style={seoLink}>
                    {val.title}
                </Link>
            ));
            return (
                <div key={idx} style={seoBlockWrapper}>
                    <div style={seoTitle}>{seo.headline}</div>
                    {seoLinks}
                </div>
            );
        });
        const title = (
            <CollapsibleDropDownTitle
                wrapperStyles={siteMapStyle}
                titleStyles={titleStyle}
                title={__('Sitemap', 'dreamlines')}
                isSeoTitle={false}
            />
        );
        const dropDownStyle = {
            title: title,
            wrapperStyle: seoWrapper,
            childStyle: seoChild,
            containerStyle: seoContainerStyle,
            titleStyle: seoTitleStyle,
            arrowStyle: seoArrow,
        };
        return <CollapsibleDropDown {...dropDownStyle}>{seoBlocks}</CollapsibleDropDown>;
    };
    const includeNewsletter: boolean = Boolean(
        [
            pageTypes.thankYouPage,
            pageTypes.shipDetailPage,
            pageTypes.frontPage,
            pageTypes.themeOverviewPage,
            pageTypes.roundtripDetailPage,
            pageTypes.roundtripOverviewPage,
        ].indexOf(props.pageType) >= 0,
    );
    const showCondensedFooter = Boolean(props.pageType === pageTypes.searchWizardPage);
    const showNewsletter = props.countryCode === 'br' || props.countryCode === 'it' ? false : true;
    const showContactUs = props.countryCode === 'br' || props.countryCode === 'it' ? false : true;
    return (
        <div style={wrapperStyle}>
            {includeNewsletter && showNewsletter && <Newsletter location="footer" />}
            {!showCondensedFooter && showContactUs && <ContactUs phoneNumber={props.phoneNumber} />}
            <div style={styleFooterWrapper}>
                <div style={styleFooterLinksWrapper}>{getFooterNavigation()}</div>
                {getFooter()}
                <div style={styleFooterCopyright}>
                    <span>&copy; </span>
                    <span style={styleFooterBold}>Dreamlines {year}</span>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: IState) => ({
    countryCode: state.pageData.appConfig.countryCode,
    footerMenu: state.pageData.footerMenu,
    footer: state.pageData.footer,
    phoneNumber: state.pageData.brandConfig.phoneNumber,
    pageType: state.router.pageType,
});

export const Footer = connect(mapStateToProps, {})(FooterComponent);
